import { VideoImage } from '../VideoContent';

const Demo6Content10 = () => {
    return (
        <section id="content-10" className="content-10 wide-100 content-section division">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-8">
                        <div className="section-title title-02 mb-60">
                            <span className="section-id txt-upcase">Extremely Flexible</span>
                            <h2 className="h2-xs">Discover powerful features to boost your productivity</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="img-block text-center video-preview wow fadeInUp">
                            <VideoImage img="/images/demo6/dashboard-07.png" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Content10;
